import { createConfirmation } from "react-confirm";
import AddYieldNameDialog from "./AddYieldNameDialog";

export const showAddYieldNameDialog = createConfirmation(AddYieldNameDialog);
